<template>
    <div class="cemetery-sector-statistic">
        <div class="total">
            <div class="info">
                <span class="title">{{ $t(`${modelTranslateID}.total_sectors`) }}</span>
                <h2 class="amount">{{ total }}</h2>
            </div>
            <a v-if="allowShowSectors && total>0"
                class="btn btn-link"
                aria-disabled="false"
                @click.prevent="onShowCemeterySectors">
                <span class="">{{ $t(`${actionsTranslateID}.see_sectors`) }}</span>
            </a>
        </div>

        <!-- <div class="total-story">
            <div class="info-story">
                <span class="title-story">Life Chronicle for Approval</span>
                <h2 class="amount">0</h2>
            </div>
        </div> -->

        <div class="detailed-statistics">
            <div class="statistics-item"
                v-for="(item, idx) in statistics"
                :key="`cemetery-statistics-item-${idx}`">
                <div class="mark" :style="{ backgroundColor: item.color }"></div>
                <div>
                    <p class="title">{{ item.name }}</p>
                    <h4 class="amount">{{ item.amount }}</h4>
                </div>
            </div>
        </div>

        <div class="total">
            <div class="info">
                <p class="title">{{ $t(`${modelTranslateID}.total_interments`) }}</p>
                <h2 class="amount">{{ total_interments }}</h2>
            </div>
        </div>
    </div>
</template>

<script>
import CemeteryElementMixin from "../mixins/CemeteryElementMixin";
import { EVENTS } from '../../../shared/config/event-constants';

export default {
    mixins: [
        CemeteryElementMixin
    ],
    components: {
    },
    props: {
        cemeteryCode: {
            type: String,
            default: null,
        },
        eventSectorsShow: {
            type: String,
            default: EVENTS.SHOW_MODAL_SECTORS,
        },
    },
    data() {
        return {

        }
    },
    computed: {
        modelTranslateID() {
            return `${this.baseTranslateID}.model.administration.sector_statistic`
        },
        actionsTranslateID() {
            return `${this.baseTranslateID}.actions.administration.sector_statistic`
        },
        total() {
            return this.value?.total ?? 0;
        },
        total_interments() {
            return this.value?.total_interments ?? 0;
        },
        statistics() {
            return this.value?.sector_statistics ?? {};
        },
        allowShowSectors() {
            return this.actions?.sector.show ?? false;
        },
    },
    methods: {
        onShowCemeterySectors() {
            this.$eventBus.publish(this.moduleCode, this.eventSectorsShow, {data: {cemetery: {code: this.cemeteryCode}}});
            this.$emit('showCemeterySectors');
        }
    }
}
</script>

<style lang="scss" scoped>
.cemetery-sector-statistic {
    color: rgba(0, 0, 0, 0.87);
    font-family: var(--city-font-family);
    font-size: 16px;
    line-height: 24px;
    letter-spacing: normal;

    .total-story {
        display: flex;
        justify-content: space-between;
        padding: 16px;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.11), 0 4px 8px rgba(0, 0, 0, 0.13);
        border-radius: 8px;
        margin-bottom: 8px;
        cursor: pointer;
        margin-left: 2px;
        margin-right: 2px;

        .title-story {
            display: block;
            margin-bottom: 5px;
            color: #673ab7;
        }

        .amount {
            font: 500 32px / 32px Roboto, "Helvetica Neue", sans-serif;
            letter-spacing: normal;
            margin: 0;
        }
    }

    .detailed-statistics {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        .statistics-item {
            display: flex;
            border: 1px solid rgba(24, 20, 41, 0.2);
            box-sizing: border-box;
            border-radius: 8px;
            width: 49%; //160px;
            margin-bottom: 8px;
            max-height: 64px;
            padding: 10px 16px 10px 0;

            .mark {
                height: 42px;
                border-top-right-radius: 80%;
                border-bottom-right-radius: 80%;
                margin-right: 12px;
                flex: 0 0 4px;
            }

            .title {
                display: block;
                margin: 0 0 4px;
                font-size: 13px;
                line-height: 15px;
                color: rgba(24, 20, 41, 0.6);
                font-family: inherit;
                text-transform: none;
            }

            .amount {
                letter-spacing: normal;
                margin: 0;
                text-transform: none;
                font-size: 19px;
                font-weight: 500;
                line-height: 24px;
            }
        }
    }

    .total {
        display: flex;
        justify-content: space-between;
        padding: 16px;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.11), 0 4px 8px rgba(0, 0, 0, 0.13);
        border-radius: 8px;
        margin-bottom: 8px;
        margin-left: 2px;
        margin-right: 2px;

        .info {
            flex: 1;
        }

        .title {
            display: block;
            margin: 0 0 5px;
            color: inherit;
            text-transform: none;
            letter-spacing: normal;
            font-size: 16px;
            line-height: 24px;
            font-family: inherit;
        }

        .amount {
            letter-spacing: normal;
            margin: 0;
            text-transform: none;
            color: inherit;
            font-size: 32px;
            font-weight: 500;
            line-height: 32px;
        }

        .btn {
            font-size: 14px;
            font-family: var(--city-medium-font-family);
            font-weight: 500;
            text-transform: uppercase;
            color: var(--primary-color);
            margin: 0;
            padding: 0 16px;
            height: 48px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex: 1;

            &:hover {
                color: var(--primary-color);
                text-decoration: none;
                box-shadow: none;
            }
        }
    }
}
</style>